import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { motion } from "motion/react";
import { DROPZONE_SPRING } from "./dropzone-spring";

/**
 * The rectangle a drag is released into, shown only while files hang over the pill. Dashed
 * because every file input in the app already draws a release point that way, so it reads as a
 * target without the label having to say so.
 *
 * It collapses its own height rather than being pulled out of the pill's flex flow, which is
 * what keeps the exit continuous: the pill's box follows a child that is still laid out, so
 * there is no frame where the rectangle has lost its width and the pill has not yet lost its
 * height. The spacing above it sits on the inner box rather than as a gap on the pill, because a
 * gap survives a collapsed child and leaves the pill 12px too tall.
 */
export function GeneralDropzoneTarget() {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<motion.div
			initial={{ height: 0, opacity: 0 }}
			animate={{ height: "auto", opacity: 1 }}
			exit={{ height: 0, opacity: 0 }}
			transition={DROPZONE_SPRING}
			className="overflow-hidden"
		>
			<div className="v-stack mt-3 items-center gap-1.5 rounded-lg border border-white/40 border-dashed py-6">
				<Icon
					name="Upload"
					size={20}
				/>
				<p className="font-medium text-sm">{t("file_upload.release_to_drop")}</p>
			</div>
		</motion.div>
	);
}
